import ArtifactGroupType from "@/roc/museum/base/ArtifactGroupType";

const HiddenHoard = {
  id: '92',
  name: 'Hidden Hoard',
  icon: 'HiddenHoard',
  groupIcon: 'LegendsOfTheHighSeas',
  type: ArtifactGroupType.LEGENDS_OF_THE_HIGH_SEAS,
  power: 10
};

export default HiddenHoard;
